export const tableToLayerName = {
    "ctrl_aerofotogrametrico": "Recobrimento Aerofotogramétrico",
    "ctrl_aerotriangulacao": "Aerotriangulação",
    "ctrl_apoio_de_campo": "Apoio de Campo",
    "ctrl_apoio_de_campo_1": "Apoio de Campo - Classe I",
    "ctrl_apoio_de_campo_2": "Apoio de Campo - Classe II",
    "ctrl_apoio_de_campo_2_pcl": "Apoio de Campo - Classe II - PCL",
    "ctrl_apoio_de_campo_2_hv_pca": "Apoio de Campo - Classe II - HV e PCA",
    "ctrl_base_hidrografica": "Base Hidrográfica",
    "ctrl_base_hidrografica_ottocodificada": "Base Hidrográfica Ottocodificada",
    "ctrl_class_nuvem_de_pontos": "Classificação da Nuvem De Pontos",
    "ctrl_curva_de_nivel": "Curvas de Nível",
    "ctrl_edicao": "Edição Gráfica",
    "ctrl_fotoindice": "Fotoíndice",
    "ctrl_img_hipsometrica": "Imagem Hipsométrica Composta",
    "ctrl_img_intensidade": "Imagem de Intensidade",
    "ctrl_laser": "Perfilamento a LASER Aerotransportado",
    "ctrl_mds": "Modelo Digital de Superficie - MDS",
    "ctrl_mdt": "Modelo Digital de Terreno - MDT",
    "ctrl_ortofotomosaico": "Ortofotomosaico RGB/NIR",
    "ctrl_reambulacao": "Reambulação",
    "ctrl_restituicao_planimetrica": "Restituição Planimétrica"
};

export const colorMap = {
    "À executar": "#D9D9D9",
    "Em andamento": '#FFFF00',
    "Executado": '#0000FF',
    "Entregue": '#1A2B4C',
    "Aprovado": '#92D050',
    "Aprovado com Pendência": '#E18FD9',
};

export const productLayerOrder = [
  "Recobrimento Aerofotogramétrico",
  "Apoio de Campo - Classe II - PCL",
  "Apoio de Campo - Classe II - HV e PCA",
  "Fotoíndice",
  "Perfilamento a LASER Aerotransportado",
  "Classificação da Nuvem De Pontos",
  "Modelo Digital de Superficie - MDS",
  "Modelo Digital de Terreno - MDT",
  "Imagem Hipsométrica Composta",
  "Imagem de Intensidade",
  "Aerotriangulação",
  "Ortofotomosaico RGB/NIR",
  "Curvas de Nível",
  "Base Hidrográfica",
  "Base Hidrográfica Ottocodificada",
  "Restituição Planimétrica",
  "Reambulação",
  "Edição Gráfica"
];

export const productHidden = [
	"Apoio de Campo - Classe II - PCL",
	"Apoio de Campo - Classe II - HV e PCA",
	"Fotoíndice",
	"Aerotriangulação",
	"Reambulação",
	"Edição Gráfica",
];

const canonicalStatusMap = {
    'a executar': 'À executar',
    'em andamento': 'Em andamento',
    'executado': 'Executado',
    'entregue': 'Entregue',
    'aprovado': 'Aprovado',
    'aprovado com pendencia': 'Aprovado com Pendência',
};

export const normalizeStatus = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') {
        return 'À executar';
    }

    const original = String(value).trim();

    const normalized = original
        .replace(/\s+/g, ' ')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

    return canonicalStatusMap[normalized] || original;
};